import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'components/v2/panels/Panel';
import Button from 'components/v2/buttons/Button';
import classnames from 'classnames';

export default function CardFooter({
  children,
  actionLabel,
  cancelLabel,
  className,
  onActionClick,
  onCancelClick,
  showCancelButton,
}) {
  return (
    <Panel className={classnames(className, 'bg-gray-50')}>
      {children}
      <div className="flex items-center justify-end space-x-4">
        <Button color="green" onClick={onActionClick}>
          {actionLabel}
        </Button>
        {showCancelButton && (
          <Button color="" onClick={onCancelClick}>
            {cancelLabel}
          </Button>
        )}
      </div>
    </Panel>
  );
}

CardFooter.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
    PropTypes.array,
  ]),
  actionLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  onActionClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  showCancelButton: PropTypes.bool,
};

CardFooter.defaultProps = {
  actionLabel: 'Save',
  cancelLabel: 'Cancel',
  showCancelButton: true,
};
